import { render, staticRenderFns } from "./PFSettlementAll.vue?vue&type=template&id=52a23cbc&scoped=true"
import script from "./PFSettlementAll.vue?vue&type=script&lang=js"
export * from "./PFSettlementAll.vue?vue&type=script&lang=js"
import style0 from "./PFSettlementAll.vue?vue&type=style&index=0&id=52a23cbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a23cbc",
  null
  
)

export default component.exports